export const MFA_CODE_PATTERN: string = '^[0-9]{6}$';
